import styled from 'styled-components';

import {
  Divider as SemanticDivider,
} from 'semantic-ui-react';

import {
  Button as ButtonLayoutComponent,
  Segment as SegmentLayoutComponent, Text as TextLayoutComponent,
} from '@playbookux/playbook-web-core';

const Container = styled(SegmentLayoutComponent)`
  &.ui.segment {
    margin-bottom: 20px;
    padding: 20px;
    width: auto;
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

const Title = styled(TextLayoutComponent.Header)`
  display: flex;
  align-items: center;
  gap: 10px;
  line-height: ${({ noLHeight }) => (noLHeight ? '0' : '1.4')};
`;

const TitleSpan = styled.span`
  font-weight: 500;
`;

const Edit = styled.a`
  cursor: pointer;
`;

const Divider = styled(SemanticDivider)`
  &.ui.divider {
    border-top: 1px solid #EDEDED;
    margin-top: 5px;
  }
`;

const ButtonsHeader = styled.div`
  & > * {
    margin-right: 15px;
  }
`;

const SaveButton = styled(ButtonLayoutComponent)`
`;

const UpgradeButton = styled(ButtonLayoutComponent)`
  &.ui.button {
    background: ${({ theme }) => theme.color.comingSoon};
    border-radius: 5px;
    color: ${({ theme }) => theme.color.buttonInvertedText};
    cursor: ${({ pointer }) => (pointer ? 'pointer' : 'not-allowed')};
    font-size: 12px;
    font-weight: 500;
    margin: 10px 20px;
    padding: 5px;
    box-shadow: unset;

    :hover {
      background: ${({ theme }) => theme.color.comingSoon};
      color: ${({ theme }) => theme.color.buttonInvertedText};
    }
  }
`;

export {
  Container,
  Divider,
  Edit,
  Header,
  Title,
  SaveButton,
  ButtonsHeader,
  UpgradeButton,
  TitleSpan,
};
